<template>
  <div class="l_select" :value="$attrs.value" @click.capture="visible = true" :class="{ active: visible }">
    <el-form-item
      :label="label"
      :prop="name"
      :class="{ tip: tip }"
      :rules="requiredByList.includes(rules) ? requiredRules : null"
    >
      <el-select
        v-on="listeners"
        v-bind="$attrs"
        :id="name"
        filterable
        :class="{ showPlaceholder: showPlaceholder }"
        :data-testid="testId || name"
        :no-data-text="emptyText"
        :disabled="disabled"
      >
        <slot></slot>
      </el-select>
    </el-form-item>
    <slot name="tip"></slot>
  </div>
</template>

<script>
export default {
  name: 'selectTemplate',
  props: {
    name: String,
    label: String,
    testId: String,
    emptyText: String,
    rules: String,
    tip: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false,
      showPlaceholder: false,
      requiredRules: [
        {
          required: true,
          message: this.$t('common.formValidation.dynamicReq', {
            dynamic: this.getRequiredMessage(this.rules)
          }),
          trigger: 'blur'
        }
      ],
      requiredByList: ['depositor', 'bank']
    };
  },
  computed: {
    listeners() {
      return Object.assign({}, this.$listeners, {
        input: event => this.$emit('input', event),
        focus: event => (this.showPlaceholder = true)
      });
    }
  },
  methods: {
    getRequiredMessage(rules) {
      switch (rules) {
        case 'depositor':
          return this.$t('deposit.localdepositor.depositor');
          break;

        default:
          return this.$t('common.formValidation.thisField');
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.l_select {
  position: relative;
  position: sticky;
  z-index: 1;

  input {
    position: sticky;
    z-index: 101;
  }

  .tip {
    margin-bottom: 20px;
  }

  &.active,
  &[value]:not([value='']) {
    /deep/ label {
      font-size: 14px;
      bottom: 45px;
    }
  }
}
</style>
